import { EcoplanetTriangleAlertIcon } from '@/src/assets/icons'
import { FlexRow } from '@/src/components'
import { BaseText } from '@/src/components/BaseText'
import TagComponent from '@/src/components/shared/tag/TagComponent'
import type { EnrichedLocations } from '@/src/contexts/LocationsContext'
import { useLoadPlanningCurrentLocation } from '@/src/features/procurement-and-markets/load-planning/contexts/LoadPlanningCurrentLocationContext'
import { appColors } from '@/src/theme/foundations/colors'
import { Flex, MenuItem } from '@chakra-ui/react'
import type { VirtualItem } from '@tanstack/react-virtual'
import { useTranslation } from 'react-i18next'

interface LoadPlanningLocationMenuItemProps {
  location: EnrichedLocations[number]
  virtualItem: VirtualItem
  eligibleLocationIds: Set<number> | undefined
}

export const LoadPlanningLocationMenuItem = ({ location, virtualItem, eligibleLocationIds }: LoadPlanningLocationMenuItemProps) => {
  const { t } = useTranslation()
  const { locationId, setLocationId } = useLoadPlanningCurrentLocation()

  const isDisabled = !eligibleLocationIds?.has(location.locationPgId)
  const isSelected = locationId === location.locationPgId

  return (
    <MenuItem
      onClick={() => setLocationId(location.locationPgId)}
      isDisabled={isDisabled}
      w={'100%'}
      color={isSelected ? 'primaryForeground' : 'foreground'}
      bg={isSelected ? 'accentPrimary' : 'background'}
      _hover={{ bg: isSelected ? 'accentPrimary' : 'muted' }}
      borderRadius='8px'
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: `${virtualItem.size}px`,
        transform: `translateY(${virtualItem.start}px)`,
      }}
    >
      <FlexRow justifyContent={'space-between'} w={'100%'} gap={4}>
        <Flex>
          <BaseText fontSize={14}>{location.name}</BaseText>
        </Flex>
        <Flex>
          {isDisabled && (
            <TagComponent
              text={t('components.procurement.forecasting.location_not_included')}
              icon={<EcoplanetTriangleAlertIcon />}
              color={{
                background: appColors.muted,
                borderColor: appColors.border,
                textColor: appColors.secondaryForeground,
              }}
              borderWidth='1px'
              borderRadius='2px'
              height='20px'
            />
          )}
        </Flex>
      </FlexRow>
    </MenuItem>
  )
}
